<script  lang="ts" setup="">
import type { BecomeAuthorData } from '~/utils/crystallize/become-author'
import type { CtaData } from '~/utils/crystallize/pieces'
import { articleSchema } from '~/utils/crystallize/article'

const props = defineProps<{
  data: NonNullable<BecomeAuthorData['components']>['highlightedArticle']
}>()

const path = computed(() => props.data?.[0]?.path)

const options = useCatalogueQueryOptions({
  path: computed(() => path.value ?? ''),
  schema: articleSchema,
})

const { data: article, suspense } = useQuery({
  ...options,
  enabled: computed(() => !!path.value),
})

await suspense()

const data = computed<CtaData>(() => {
  const graphic = article.value?.components?.headerImage
  return {
    title: article.value?.components?.title,
    text: article.value?.components?.leadParagraph,
    action: [
      {
        label: 'Les artikkel',
        link: path.value,
      },
    ],
    graphic: graphic && {
      firstImage: graphic,
      images: [graphic],
    },
  }
})
</script>

<template>
  <BecomeAuthorCta :data="data" class="bg-blurple-50" />
</template>
